import {BaseService} from "../../../global/classes";
import axios from "axios";
import config from "../../../config";

// O serviço de link valida o JWT da API antiga, não o do VAULT: por isso o token
// destas chamadas é o legado. O `accessToken` era o próprio token legado até o
// login passar pelo VAULT — de lá para cá virou o do VAULT e o serviço de link
// devolvia 401.
export default class LinkDeAssinaturaService extends BaseService{
  createLink = async (data: any) => {
    try {
      await axios.post(`${config.wlBaseurl}/link-pagamento/assinatura/criar/${this.selectedCompany?.merchantId}`, {...data},
        {
          headers: {
            Authorization: `Bearer ${this.legacyAccessToken?.token}`,
          },
          params: {
            businessId: this.selectedCompany?.id
          }
        })
    } catch (error) {
      throw error;
    }
  }

  getAllLinks = async (selectedBusiness: any, user: any) => {
    try {
      const response = await axios.get(`${config.wlBaseurl}/link-pagamento/assinatura/listar/${selectedBusiness.merchantId}/${user.id}`,
        {
          headers: {
            Authorization: `Bearer ${this.legacyAccessToken?.token}`
          }
        });

      return response.data;
    }
    catch (error) {
      throw error;
    }
  }

  deleteLinkById = async (id: string) => {
    try {
      const response = await axios.delete(`${config.wlBaseurl}/link-pagamento/deletar/${id}`, {
        headers: {
          Authorization: `Bearer ${this.legacyAccessToken?.token}`
        }
      });

      return response.status;
    } catch (error) {
      throw error;
    }
  }
}
